<div
  [class]="cssClassName()"
  [style]="styles()"
  class="iot-platform-ui-section-header flex flex-wrap items-center gap-2.5"
  data-cy="iot-platform-ui-section-header"
>
  <div
    [matTooltip]="title()"
    matTooltipClass="regular-tooltip"
    matTooltipPosition="below"
    class="iot-platform-ui-section-header__title-section flex items-center gap-2.5"
  >
    @if (!!svgIcon()) {
      <mat-icon data-cy="iot-platform-ui-section-header-icon" class="iot-platform-ui-section-header__icon" [svgIcon]="svgIcon()!"></mat-icon>
    } @else if (!!icon()) {
      <mat-icon data-cy="iot-platform-ui-section-header-icon" class="iot-platform-ui-section-header__icon">{{ icon() }}</mat-icon>
    }
    @if (titleActions().length) {
      <div class="flex items-center gap-2.5">
        <ng-container [ngTemplateOutlet]="sectionHeaderTitle" [ngTemplateOutletContext]="{ title: title() }" />

        <button class="light-button iot-platform-ui-section-header__action" mat-mini-fab [matMenuTriggerFor]="titleMenu">
          <mat-icon data-cy="iot-platform-ui-section-header-icon" class="iot-platform-ui-section-header__action-icon">arrow_drop_down</mat-icon>
        </button>
      </div>

      <mat-menu #titleMenu="matMenu">
        @for (action of titleActions(); track action) {
          <ng-container [ngTemplateOutlet]="sectionHeaderActionMenu" [ngTemplateOutletContext]="{ action: action }" />
        }
      </mat-menu>
    } @else if (title()) {
      <ng-container [ngTemplateOutlet]="sectionHeaderTitle" [ngTemplateOutletContext]="{ title: title() }" />
    }
  </div>

  <ng-content select="[nameMeta]" />

  @if (showLine()) {
    <hr class="iot-platform-ui-section-header__line regular-1px-line flex-1" />
  }

  @if (actionsType() === SectionHeaderActionsType.ICONS) {
    <div class="flex flex-wrap gap-2.5">
      @for (action of actions(); track action) {
        @if (!!action?.visible?.()) {
          <ng-container [ngTemplateOutlet]="sectionHeaderActionIcon" [ngTemplateOutletContext]="{ action: action }" />
        }
      }
    </div>
  } @else if (actionsType() === SectionHeaderActionsType.MENU) {
    <button class="light-button iot-platform-ui-section-header__action" mat-mini-fab [matMenuTriggerFor]="actionsMenu">
      <mat-icon data-cy="iot-platform-ui-section-header-icon" class="iot-platform-ui-section-header__action-icon">add</mat-icon>
    </button>

    <mat-menu #actionsMenu="matMenu">
      @for (action of actions(); track action) {
        @if (!!action?.visible?.()) {
          <ng-container [ngTemplateOutlet]="sectionHeaderActionMenu" [ngTemplateOutletContext]="{ action: action }" />
        }
      }
    </mat-menu>
  }
</div>

<ng-template #sectionHeaderActionIcon let-action="action">
  <button
    (click)="onDispatchEvent(action)"
    [class]="
      action?.cssClassName?.() +
      ' light-button regular-round-button iot-platform-ui-section-header__action iot-platform-ui-section-header__action_' +
      action.action
    "
    [disabled]="!!action?.disabled?.()"
    [matTooltip]="$safeNavigationMigration(action?.tooltip?.())! | translate"
    [style]="action?.styles?.()"
    data-cy="iot-platform-ui-section-header-action"
    mat-mini-fab
    matTooltipClass="regular-tooltip"
    matTooltipPosition="below"
  >
    @if (!!action?.svgIcon?.()) {
      <mat-icon class="iot-platform-ui-section-header__action-icon" [svgIcon]="action.svgIcon()!"></mat-icon>
    } @else if (!!action?.icon?.()) {
      <mat-icon class="iot-platform-ui-section-header__action-icon">{{ action.icon() }}</mat-icon>
    }
  </button>
</ng-template>

<ng-template #sectionHeaderActionMenu let-action="action">
  <button
    (click)="onDispatchEvent(action)"
    [class]="action?.cssClassName?.()"
    [disabled]="!!action?.disabled?.()"
    [matTooltip]="$safeNavigationMigration(action?.tooltip?.())! | translate"
    [style]="action?.styles?.()"
    mat-menu-item
  >
    <div class="flex items-center gap-1">
      <span>
        {{ action.text() | translate }}
      </span>

      @if (!!action?.svgIcon?.()) {
        <mat-icon class="iot-platform-ui-section-header__action-icon" [svgIcon]="action.svgIcon()!"></mat-icon>
      } @else if (!!action?.icon?.()) {
        <mat-icon class="iot-platform-ui-section-header__action-icon">{{ action.icon() }}</mat-icon>
      }
    </div>
  </button>
</ng-template>

<ng-template #sectionHeaderTitle let-title="title">
  <span class="iot-platform-ui-section-header__title iot-platform-ui-section-header__title--ellipsis" data-cy="iot-platform-ui-section-header-title">{{
    title
  }}</span>
</ng-template>
